import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalKcsComponent } from 'src/app/_directives/modal/kcs-modal';
import { Button } from 'src/app/_models/modal/Button';
import { SpinnerService } from 'src/app/_services/SpinnerService';
import { ConfigService } from '../../_services/config.service';
import { CompaniesService } from '../../companies/services/companies.service';
import { PortalService } from '../../portale/_services/portal.service';
import { NotificationsService } from '../../notifications/_services/notifications.service';
import { MessagingService } from '../../messaging/_services/messaging.service';
import { CompanyUiConfigService } from '../../_services/company-ui-config.service';

@Component({
	standalone: false,
	selector: 'app-header',
	templateUrl: './app-header.component.html',
	styleUrls: ['./app-header.component.css'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
	@ViewChild('changeLanguageModal') changeLanguageModal!: TemplateRef<any>;

	language: string = 'it';
	modalButtons: Button[] = [
		{ label: 'Annulla', class: 'kcs-button-outlined', action: () => this.closeModal() },
		{ label: 'Salva', class: 'kcs-button', action: () => this.saveLanguage() },
	];

	unreadCount = 0;
	unreadMessagesCount = 0;
	private unreadInterval: any;
	showNotifications = true;
	showChat = true;

	currentUser: any = null;
	currentUserAdmin: any = null;
	portale: string = '';
	protalObject: any;
	select_company: any;
	//menuItems: any[] = [];
	aziende: any[] = [];
	aliasCompanies: any[] = [];
	loginAttivo = false;
	fotocaricata = false;
	foto: string = '';
	logo = '';
	menuview = false;
	active_portal_name = '';
	active_company_name = '';
	active_user_name = '';

	sel_portali: any[] = [];
	sel_portale: any;

	sel_companies: any[] = [];
	sel_company: any;
	totalCompanies = 0;

	sel_users: any[] = [];
	sel_user: any;
	totalUsers = 0;

	order = '';
	limitda = 1;

	constructor(
		private router: Router,
		private portalservice: PortalService,
		public sanitizer: DomSanitizer,
		public configService: ConfigService,
		private companiesService: CompaniesService,
		private modalService: NgbModal,
		private translate: TranslateService,
		private portalService: PortalService,
		private spinnerService: SpinnerService,
		private notificationsService: NotificationsService,
		private messagingService: MessagingService,
		private companyUiConfigService: CompanyUiConfigService,
	) {}

	ngOnInit() {
		const sidebar = document.getElementById('asidebutton');
		if (sidebar) sidebar.click();
		this.currentUser = this.configService.getLocalStorageObjectJson('currentUser');
		if (this.currentUser != null) {
			this.loginAttivo = true;
			/*const portale = this.configService.getLocalStorageObjectJson('portale');
			this.loginAttivo = true;
			this.portalservice.getMenuItems(this.configService.getPortalID(), this.configService.getCompany_id()).subscribe((menuItems) => {
				this.menuItems = menuItems;
			});*/
		}
		if (localStorage.getItem('portale')) {
			this.protalObject = this.configService.getLocalStorageObjectJson('portale');
			this.portale = this.protalObject.pt_descrizione;
			this.logo = this.configService.getCompanyLogo();
			this.active_portal_name = this.getActivePortalName();
			this.getPortali();
		}

		if (localStorage.getItem('def_company_name')) {
			this.active_company_name = localStorage.getItem('def_company_name') || '';
			this.getCompany('');
		}

		const admin = localStorage.getItem('currentUserAdmin');
		if (admin) {
			this.currentUserAdmin = JSON.parse(admin);
		}
		if (localStorage.getItem('currentUser')) {
			let user = localStorage.getItem('currentUser');
			if (user) this.active_user_name = JSON.parse(user).usr_username || '';
			this.getUsers('');
		}

		this.language = this.translate.currentLang;

		const uiConfig = this.companyUiConfigService.getConfig();
		this.showNotifications = uiConfig.showNotifications !== false;
		this.showChat = uiConfig.showChat !== false;

		if (this.showNotifications || this.showChat) {
			this.loadUnreadCount();
			this.loadUnreadMessagesCount();
			this.unreadInterval = setInterval(() => {
				this.loadUnreadCount();
				this.loadUnreadMessagesCount();
			}, 60000);
		}
	}

	ngOnDestroy() {
		if (this.unreadInterval) {
			clearInterval(this.unreadInterval);
		}
	}

	loadUnreadCount() {
		if (this.loginAttivo && this.showNotifications) {
			this.notificationsService.GetUnreadCount().subscribe({
				next: (count) => (this.unreadCount = count),
				error: () => {},
			});
		}
	}

	loadUnreadMessagesCount() {
		if (this.loginAttivo && this.showChat) {
			this.messagingService.getUnreadCount().subscribe({
				next: (count) => (this.unreadMessagesCount = count),
				error: () => {},
			});
		}
	}

	goToNotifications() {
		this.router.navigate(['/notifications/lista']);
	}

	goToMessaging() {
		this.router.navigate(['/messaging/lista']);
	}

	ngAfterViewInit() {
		if (localStorage.getItem('portale')) {
			//Abilito la selezione portale nel header
			if (this.sel_portali.length > 1) {
				document.getElementById('portal_selection')?.classList.add('selectable');
			}
		}
		if (localStorage.getItem('def_company_name')) {
			if (this.totalCompanies > 1) {
				document.getElementById('company_selection')?.classList.add('selectable');
			}
		}
	}

	getAliasCompanies(pt_id: number) {
		this.portalservice.getAliasCompanies(pt_id).subscribe((res: any) => {
			if (res) {
				this.aliasCompanies = res;

				for (let i = 0; i < this.aziende.length; i++) {
					for (let j = 0; j < this.aliasCompanies.length; j++) {
						if (this.aliasCompanies[j] === this.aziende[i].id) {
							this.aziende[i].cmp_isChecked = true;
						}
					}
				}
				this.aziende = this.aziende.filter((x) => x.cmp_isChecked);
				if (this.aziende) {
					if (this.aziende.length == 1) {
						//TODO this.default_company_name = this.aziende[0].name;
					}
				}
			}
		});
	}
	cambioLista() {
		if (this.menuview) {
			this.menuview = false;
			let sidebar = document.getElementById('sidebar1');
			if (sidebar) {
				sidebar.removeAttribute('hidden');
				sidebar.setAttribute('visible', '');
				this.modifySidebarCSS('16rem');
			}

			localStorage.setItem('menuview', 'false');
		} else {
			this.menuview = true;
			let sidebar = document.getElementById('sidebar1');
			if (sidebar) {
				sidebar.removeAttribute('visible');
				sidebar.setAttribute('hidden', '');
				this.modifySidebarCSS('0rem');
			}
			localStorage.setItem('menuview', 'true');
		}
	}

	modifySidebarCSS(value: string) {
		// Trova tutti i fogli di stile caricati
		const styleSheets = Array.from(document.styleSheets) as CSSStyleSheet[];

		for (const sheet of styleSheets) {
			try {
				// Trova le regole CSS
				const rules = Array.from(sheet.cssRules || sheet.rules);

				for (const rule of rules) {
					// Cerca la regola @media con il selettore specificato
					if (rule instanceof CSSMediaRule && rule.conditionText === '(min-width: 992px)') {
						const sidebarRule = Array.from(rule.cssRules).find((r) => r.cssText.includes('.sidebar:not(.hide)'));

						if (sidebarRule && sidebarRule instanceof CSSStyleRule) {
							// Modifica la proprietà --cui-sidebar-occupy-start
							sidebarRule.style.setProperty('--cui-sidebar-occupy-start', value);
							return; // Interrompi il ciclo dopo aver modificato
						}
					}
				}
			} catch (e) {
				console.error("Errore nell'accesso al foglio di stile", e);
			}
		}
	}

	gotoLogin(doLogout?: boolean) {
		if (doLogout) {
			localStorage.removeItem('login');
			localStorage.clear();
			sessionStorage.clear();
			this.loginAttivo = false;
			this.fotocaricata = false;
			console.log('gotoLogin doLogout login_due_fattori');
			this.router.navigate(['/login_due_fattori']);
		} else {
			localStorage.removeItem('portale');
			this.activatePortale();
			console.log('gotoLogin else login_due_fattori');
			this.router.navigate(['/login_due_fattori']);
		}
	}

	navigateTo(url: any) {
		this.router.navigate(['/' + url]);
	}

	activatePortale() {
		this.portalservice.activateSceltaPortale();
	}

	goToProfile() {
		this.router.navigate(['/profile']);
	}

	changeLanguage() {
		const modalRef = this.modalService.open(ModalKcsComponent, { ariaLabelledBy: 'modal-title' });
		modalRef.componentInstance.openModal('Seleziona Lingua', '', this.modalButtons, 'primary', this.changeLanguageModal);
		modalRef.result.then(
			() => {
				console.log('lang se');

				this.closeModal();
			},
			() => {
				console.log('lang ko');
				this.closeModal();
			},
		);
	}

	saveLanguage() {
		this.configService.setLanguage(this.language);
		this.closeModal();
		window.location.reload();
	}

	closeModal() {
		this.modalService.dismissAll();
	}

	changePortal() {
		this.gotoLogin(false);
	}

	signOut() {
		this.gotoLogin(true);
	}

	getActivePortalName(): string {
		let portale_json = localStorage.getItem('portale');
		try {
			if (portale_json) {
				let portale_json_parsed = JSON.parse(portale_json);
				return portale_json_parsed.pt_descrizione;
			}
		} catch (error) {
			console.error('Cannot get portal pt_descrizione from portale_json_parsed');
		}
		return '';
	}

	getActiveCompanyName(): string {
		let company_name = localStorage.getItem('def_company_name');
		if (company_name) {
			return company_name;
		}
		return '';
	}

	getPortali() {
		if (this.configService.getUser()) {
			this.portalService.getPortaliUser(this.configService.getUser().usr_id).subscribe((res: any) => {
				this.sel_portali = res;
			});
		}
	}

	getCompany(cerca: string) {
		this.companiesService.GetListCompanies(-1, cerca, this.order, 50, this.limitda).subscribe((res: any) => {
			this.sel_companies = res;
			if (!cerca) {
				this.totalCompanies = res.length;
			}
		});
	}

	getUsers(cerca: string) {
		this.portalService.GetListUtenti(cerca, this.order, this.limitda, 50, this.configService.getCompany_id()).subscribe((res: any) => {
			this.sel_users = res;
			if (!cerca) {
				this.totalUsers = res.length;
			}
		});
	}

	selectPortale(portale?: any) {
		this.spinnerService.show('app');

		let tmp_portale = this.sel_portale;
		if (portale) {
			tmp_portale = portale;
		}

		tmp_portale.total_rows = this.sel_portali.length;

		this.portalService.setPortale(tmp_portale.pt_id).subscribe((res: any) => {
			localStorage.setItem('portale', JSON.stringify(tmp_portale));
			let currentUser = this.configService.getUser();
			currentUser.token = res.res;
			localStorage.setItem('currentUser', JSON.stringify(currentUser));
			this.router.navigate(['/']);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		});
	}

	selectCompany() {
		this.spinnerService.show('app');
		//Set cpompany Name
		localStorage.setItem('def_company_name', this.sel_company.name);

		this.configService.setCompany_id(this.sel_company.id);
		// Set logo
		const logo = this.sel_company.cmp_logo_b64 ? 'data:image/png;base64,' + this.sel_company.cmp_logo_b64 : '';

		this.router.navigate(['/']);
		setTimeout(() => {
			this.configService.setCompanyLogo(logo);
			window.location.reload();
		}, 100);
	}
	selectUser() {
		//chiamo per avere l'utente come in login
		//prendo il currentUser e lo metto in currentUserAdmin prendo il risultato della chiamata e lo metto come current user

		// Salva l'utente corrente come admin (se non è già un impersonificato)
		const currentUser = this.configService.getUser();
		if (currentUser && !localStorage.getItem('currentUserAdmin')) {
			localStorage.setItem('currentUserAdmin', JSON.stringify(currentUser));
			this.currentUserAdmin = currentUser;
		}
		// Imposta il nuovo utente selezionato
		this.portalService.loginAsUser(this.sel_user.usr_id).subscribe((response: any) => {
			if (response && response.usr_username && response.token) {
				const impersonatedUser = response;
				impersonatedUser.token = response.token;

				// Aggiorna currentUser
				localStorage.setItem('currentUser', JSON.stringify(impersonatedUser));

				// Aggiorna nome utente attivo
				this.active_user_name = impersonatedUser.usr_username;
			}
			this.router.navigate(['/']);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		});
	}

	restoreAdmin() {
		const adminUser = localStorage.getItem('currentUserAdmin');
		if (adminUser) {
			const parsedAdmin = JSON.parse(adminUser);
			localStorage.setItem('currentUser', JSON.stringify(parsedAdmin));
			localStorage.removeItem('currentUserAdmin');

			this.currentUserAdmin = null;
			this.active_user_name = parsedAdmin.usr_username;

			this.spinnerService.hide('app');
			this.router.navigate(['/']);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		}
	}

	onComapnyFilterChange(event: any) {
		const filterValue = event.filter; // Ottieni il valore del filtro
		if (filterValue && filterValue.length >= 3) {
			this.getCompany(filterValue);
		}
	}

	onUserFilterChange(event: any) {
		const filterValue = event.filter; // Ottieni il valore del filtro
		if (filterValue && filterValue.length >= 3) {
			this.getUsers(filterValue);
		}
	}
}
